
import XHeader from 'vux/src/components/x-header/index.vue'
import Panel from 'vux/src/components/panel/index.vue'
import Swiper from 'vux/src/components/swiper/swiper.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import XButton from 'vux/src/components/x-button/index.vue'

import {BaiduMap, BmMarker, BmLabel, BmOverlay} from 'vue-baidu-map'
export default {
name: 'dormroom',
props: [],
components: {
XHeader,
Panel,
Swiper,
Flexbox,
FlexboxItem,
XButton,
BaiduMap,
BmMarker,
BmLabel,
BmOverlay
},
data () {
return {
demo01_index: 0,
bannaerList: [{
url: 'javascript:',
img: require('@/assets/sass/images/dormroom/banner.png'),
title: '送你一朵fua'
}, {
url: 'javascript:',
img: require('@/assets/sass/images/dormroom/banner.png'),
title: '送你一辆车'
}, {
url: 'javascript:',
img: require('@/assets/sass/images/dormroom/banner.png'),
title: '送你一次旅行',
fallbackImg: 'https://ww1.sinaimg.cn/large/663d3650gy1fq66vw50iwj20ff0aaaci.jpg'
}],
imgsrc: '',
imgErrorUrl: 'this.src="' + require('@/assets/sass/images/default.png') + '"',
zoom: 16,
center: {
lat: 30.82825,
lng: 104.197039
},
contactInfo: {
position: {
lat: 30.82825,
lng: 104.197039
}
},
mapStyle: {
styleJson: [
{
'featureType': 'all',
'elementType': 'geometry',
'stylers': {
'hue': '#007fff',
'saturation': 89
}
},
{
'featureType': 'water',
'elementType': 'all',
'stylers': {
'color': '#ffffff'
}
}
]
}
}
},
computed: {
title () {
return this.$route.meta.title
}
},
created () {},
mounted () {},
updated () {},
destroyed () {},
watch: {},
methods: {
back () {
setTimeout(() => {
this.$router.back(-1)
}, 300)
},
goChoseRoom () {
this.$router.push({
name: 'dormChoseRoom'
})
},
onFocus () {

},
onCancel () {
},
onSubmit () {
this.$refs.search.setBlur()
this.$vux.toast.show({
type: 'text',
position: 'top',
text: 'on submit'
})
},
onImgError (item, $event) {
console.log(item)
},
draw ({el, BMap, map}) {
this.getContactInfo().then(() => {
const pixel = map.pointToOverlayPixel(new BMap.Point(this.contactInfo.position.lng, this.contactInfo.position.lat))
el.style.left = pixel.x - 82 + 'px'
el.style.top = pixel.y + 'px'
})
}
}
}



// WEBPACK FOOTER //
// ./src/yingxin/tskjxy/views/items/dormroom/dormroomDeatil.vue